export default "TABS_MODULE";
